export default [
  // 中信项目-兑换码页面定制 同步 T1006282
  {
    path: '/citicSync',
    name: 'citicSync',
    meta: { title: '提卡码' },
    component: () => import('@/views/citicSync/index')
  },
  {
    path: '/citicSyncList',
    name: 'citicSyncList',
    meta: { title: '提卡码' },
    component: () => import('@/views/citicSync/list')
  },
  {
    path: '/citicSyncCrowded',
    name: 'citicSyncCrowded',
    meta: { title: '提卡码' },
    component: () => import('@/views/citicSync/crowded')
  },
  {
    path: '/citicSyncOutStock',
    name: 'citicSyncOutStock',
    meta: { title: '提卡码' },
    component: () => import('@/views/citicSync/outStock')
  },
  // 中信项目-套餐兑换码页面定制 同步 T1006282
  {
    path: '/citicPackageSync',
    name: 'citicPackageSync',
    meta: { title: '提卡码' },
    component: () => import('@/views/citicSync/packageIndex')
  },
  {
    path: '/citicPackageSyncList',
    name: 'citicPackageSyncList',
    meta: { title: '提卡码' },
    component: () => import('@/views/citicSync/packageList')
  }
]
